import { useRef, useState } from 'preact/hooks';

export default function usePullToRefresh(onRefresh, threshold = 50) {
  const startYRef = useRef(0);
  const [refreshHeight, setRefreshHeight] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const handleTouchStart = e => {
    if (window.scrollY === 0) {
      setRefreshHeight(0);
      startYRef.current = e.touches[0].clientY;
    }
  };

  const handleTouchMove = e => {
    const currentY = e.touches[0].clientY;
    const diffY = currentY - startYRef.current;
    if (diffY > 0 && !refreshing) {
      setRefreshHeight(Math.min(diffY, 100));
    }
  };

  const handleTouchEnd = () => {
    if (refreshHeight > threshold) {
      setRefreshing(true);
      onRefresh().finally(() => {
        setRefreshing(false);
        setRefreshHeight(0);
      });
    } else {
      setRefreshHeight(0);
    }
  };

  return {
    refreshing,
    refreshHeight,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  };
}
